"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = ["1 to 250", "251 to 500", "501 to 1,000", "1,001 to 5,000", "5,001 +"];
exports.default = _default;
//# sourceMappingURL=number_of_employees_at_location.js.map